import React from "react";
import { Box, Link, Typography } from "@mui/material";
import FacebookIcon from "../../ui/facebook";
import ShareLink from "../../ui/CopyLink";
import PinterestIcon from "../../ui/Pinterest";
import TwitterIcon from '@mui/icons-material/Twitter';
import PropTypes from "prop-types";
import common from "../../utils/common";
import {CopyToClipboard} from 'react-copy-to-clipboard';

const facebookLink = url => `https://www.facebook.com/sharer/sharer.php?u=https://${window.location.host}${url}`;
const twitterLink = url => `https://twitter.com/share?url=https://${window.location.host}${url}`;
const pinterestLink = (url, thumbnailUrl, description) => `https://pinterest.com/pin/create/button/?url=https://${window.location.host}${url}&media=${thumbnailUrl}&description=${encodeURI(description)}`;
const MediaDetails = props => {
    const {content, width} = props;
    const url = common.generateAssetUrlFrom(content)
    const linkToCopy = `https://${window.location.host}${url}`;


    return <Box display={'flex'} width={width} alignSelf={'center'} flexWrap={'wrap'}>
        <Box mt={1} width={'100%'}>
            <Typography variant={"subtitle2"} fontWeight={"normal"}>{content.title}</Typography>
        </Box>
        { content.description && <Box pt={2} width={'100%'}>
            <Typography>{content.description}</Typography>
        </Box> }
        <Box pt={2} display={"flex"} alignItems={"center"} width={'100%'}>
            <Box display="flex">
                <Link href={facebookLink(url)} target="_blank">
                    <FacebookIcon sx={{ml: "-8px"}} />
                </Link>
                <Link href={twitterLink(url)} sx={{ml:1}} target="_blank">
                    <TwitterIcon htmlColor="#000000"/>
                </Link>
                <Link href={pinterestLink(url, content.asset.thumbnailUrl, content.description)} sx={{ml:1}} target="_blank">
                    <PinterestIcon  />
                </Link>
                <CopyToClipboard text={linkToCopy}>
                    <span>
                        <ShareLink size="22px" sx={{ml:1, cursor: 'pointer'}} />
                    </span>
                </CopyToClipboard>
            </Box>
        </Box>
    </Box>
}

MediaDetails.propTypes = {
    content: PropTypes.object.isRequired,
    ambassador: PropTypes.object,
    qtyProducts: PropTypes.number
}

MediaDetails.defaultProps = {
    qtyProducts: 0,
    ambassador: null
}

export default MediaDetails;